// Çek üzrə endirim (KT-101): ümumi endirim sətirlərə məbləğ payına görə bölünür — tam qəpiklə (float yoxdur),
// qalan qəpiklər ən böyük qalıqlı sətirlərə (largest remainder): cəm həmişə dəqiq endirimə bərabərdir.
// ƏDV sonra hər sətir üzrə serverdə hesablanır (endirimli sətir məbləğindən), yarım qəpik yuxarı.

/** discountKop qəpiki baseKop[] sətirlərinə bölür. Hər pay öz sətrindən çox olmur; cəm = min(discountKop, cəm). */
export function splitDiscount(baseKop: number[], discountKop: number): number[] {
  const total = baseKop.reduce((s, b) => s + Math.max(0, b), 0);
  const d = Math.max(0, Math.min(Math.trunc(discountKop), total));
  if (total === 0 || d === 0) return baseKop.map(() => 0);
  const T = BigInt(total);
  const D = BigInt(d);
  const parts = baseKop.map((b, i) => {
    const num = D * BigInt(Math.max(0, b));
    return { i, share: num / T, rem: num % T, base: b };
  });
  let left = d - parts.reduce((s, p) => s + Number(p.share), 0);
  const order = [...parts].sort((a, b) => (a.rem === b.rem ? b.base - a.base || a.i - b.i : a.rem > b.rem ? -1 : 1));
  for (const p of order) {
    if (left <= 0) break;
    p.share += 1n;
    left -= 1;
  }
  return parts.map((p) => Number(p.share));
}

/** Faizdən məbləğ (qəpik): cəm × faiz / 100, yarım qəpik yuxarı. pct 0..100, 2 onluğa qədər. */
export function percentOf(totalKop: number, pct: number): number {
  const p = BigInt(Number(Math.abs(pct).toFixed(2).replace('.', '')));
  return Number((BigInt(Math.max(0, totalKop)) * p * 2n + 10_000n) / 20_000n);
}
